var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutSpSa',[_c('section',{key:_vm.idCliente,attrs:{"id":"clienti"}},[(_vm.clienteAttivo)?_c('FormClienteSpSa',{attrs:{"clienteAttivo":_vm.clienteAttivo},on:{"cliente":_vm.cliente}}):_c('ElencoClientiSpSa',{key:JSON.stringify(_vm.clienti),attrs:{"headers":_vm.cols,"clienti":_vm.clienti},on:{"order":_vm.order,"cliente":_vm.cliente}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }